import { identity } from 'ramda'
import { useEffectAfterMount, useOnStopTyping } from '@btime/react-hooks'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { formatOptionsFromCollection } from '../../utils/helpers/select'
import FilterSideModalLoader from './FilterSideModalLoader'
import Input from '../form/Input'
import SideModal, { SideModalHeader } from '../structure/SideModal'

const Options = ({ labelKey, options, dataHook, mapOptions, renderOptions, open, localValue, setLocalValue }) => {
  dataHook = dataHook || identity
  const data = dataHook()
  options =
    options ||
    (!!mapOptions ? mapOptions(data || []) : formatOptionsFromCollection(labelKey || 'name', 'id', data || []))

  const optionsDOM = React.useMemo(() => {
    return open && renderOptions(options, localValue, setLocalValue)
  }, [options, localValue, open])

  return optionsDOM
}

const FilterSideModal = ({
  startsOpen,
  value,
  options,
  icon,
  label,
  renderOptions,
  cleanValue,
  dataHook,
  mapOptions,
  labelKey,
  renderHeaderRightContent,
  useSearch,
  open,
  onClose,
  ...props
}) => {
  const { t } = useTranslation()
  const [localValue, setLocalValue] = React.useState(value)

  useEffectAfterMount(() => {
    setLocalValue(value)
  }, [value])

  const [search, setSearch] = React.useState('')
  const finalSearch = useOnStopTyping(search)
  const clearSearch = () => setSearch('')

  const handleClose = React.useCallback(() => {
    if (onClose) onClose(localValue)
  }, [localValue, onClose])

  renderHeaderRightContent = renderHeaderRightContent || (() => {})

  return (
    <SideModal open={open} _onClose={handleClose}>
      <SideModalHeader
        title={t('filterBy') + ' ' + label}
        onClose={handleClose}
        useReturn
        rightContent={renderHeaderRightContent({ value: localValue, setValue: setLocalValue, search })}
      />

      {useSearch && (
        <Input
          placeholder="Busca"
          iconLeft="BsSearch"
          noBorder
          onChange={setSearch}
          value={search}
          iconSize="0.9rem"
          iconRight={search && 'BsX'}
          iconRightAction={clearSearch}
        />
      )}

      <FilterSideModalLoader {...props} search={finalSearch}>
        <Options
          options={options}
          labelKey={labelKey}
          dataHook={dataHook}
          mapOptions={mapOptions}
          renderOptions={renderOptions}
          open={open}
          localValue={localValue}
          setLocalValue={setLocalValue}
        />
      </FilterSideModalLoader>
    </SideModal>
  )
}

export default FilterSideModal
